__turbopack_context__.v({
  "blurTooltip": "QueuePlan-module-scss-module___suMWG__blurTooltip",
  "center": "QueuePlan-module-scss-module___suMWG__center",
  "center__text": "QueuePlan-module-scss-module___suMWG__center__text",
  "d2": "QueuePlan-module-scss-module___suMWG__d2",
  "d2__svg": "QueuePlan-module-scss-module___suMWG__d2__svg",
  "d2__text": "QueuePlan-module-scss-module___suMWG__d2__text",
  "dash": "QueuePlan-module-scss-module___suMWG__dash",
  "firstActive": "QueuePlan-module-scss-module___suMWG__firstActive",
  "firstQueue": "QueuePlan-module-scss-module___suMWG__firstQueue",
  "human": "QueuePlan-module-scss-module___suMWG__human",
  "image": "QueuePlan-module-scss-module___suMWG__image",
  "innerBox": "QueuePlan-module-scss-module___suMWG__innerBox",
  "k1_1": "QueuePlan-module-scss-module___suMWG__k1_1",
  "mck": "QueuePlan-module-scss-module___suMWG__mck",
  "mck__pointer": "QueuePlan-module-scss-module___suMWG__mck__pointer",
  "park": "QueuePlan-module-scss-module___suMWG__park",
  "pointer": "QueuePlan-module-scss-module___suMWG__pointer",
  "queueBox": "QueuePlan-module-scss-module___suMWG__queueBox",
  "queueBoxMob": "QueuePlan-module-scss-module___suMWG__queueBoxMob",
  "root": "QueuePlan-module-scss-module___suMWG__root",
  "scrollSnap": "QueuePlan-module-scss-module___suMWG__scrollSnap",
  "secondActive": "QueuePlan-module-scss-module___suMWG__secondActive",
  "secondQueue": "QueuePlan-module-scss-module___suMWG__secondQueue",
  "svg": "QueuePlan-module-scss-module___suMWG__svg",
  "tooltipBox": "QueuePlan-module-scss-module___suMWG__tooltipBox",
  "tooltipBox__time": "QueuePlan-module-scss-module___suMWG__tooltipBox__time",
  "tooltipWrapper": "QueuePlan-module-scss-module___suMWG__tooltipWrapper",
  "tooltipWrapperInner": "QueuePlan-module-scss-module___suMWG__tooltipWrapperInner",
});
